import { trackEvent } from "@garantidos/utils/tracking"

const openAccount = (hashedCpf) => {
  const ga4 = {
    customPath:
      "credito/cgimovel/quitado/contratacao/env-proposta/envio-proposta-sucesso",
    hashedCpf,
    implementationTeam: "cgi:v01",
    eventName: "click",
    detail: "envio-proposta-sucesso-abra-sua-conta"
  }

  const ga = {
    label: "BTN:CGI:AbraSuaConta",
    action: "EnvioPropostaRV",
    hashedCpf
  }

  const segment = "crossell-open-account-proposal-cgi"

  trackEvent({ ga, ga4, segment })
}

export { openAccount }
